<template>
    <div>
        <div>
            <van-cell-group>
                <van-field label="学号" :value="sno" readonly />
                <van-field label="户名" :value="name" readonly />
                <van-field name="picker" :value="bankName" label="选择银行" placeholder="请选择银行" required readonly
                @click="chooseBank" />
                <van-popup v-model="showPicker" position="bottom">
                    <van-search placeholder="请输入银行名称" v-model="bankSearchValue"/>
                    <van-picker
                        show-toolbar
                        :columns="getBankList(1)"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <van-field v-model="bankCardNum" label="银行卡号" placeholder="请输入银行卡号" :readonly="isForbidden" required/>
                
            </van-cell-group>
        </div>
        <div
                style="
        margin-top: 20px;
        width: 100%;
        height: 100%;
        background-color: #f4f4f5;
      "
        >
            <mobile-button style="display: flex;justify-content: center;margin: 0px 5px;" v-if="showHandler" color="#ab2c31" @click="onSubmit">
                提交
            </mobile-button>
        </div>
        <van-overlay :show="showloading" @click="showloading = false">
            <div
                    style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
        "
                    @click.stop
            >
                <van-loading vertical>加载中...</van-loading>
            </div>
        </van-overlay>
    </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
    import MobileButton from "components/mobile-button/index";
    import apiLoginPage from "api/login-page";
    import {Toast} from "vant";
    import {Dialog} from "vant";
    import {Overlay} from "vant";

    export default {
        components: {
            MobileButton,
        },
        data() {
            return {
                sno:'',
                name:'',
                bankName: '',
                bankCardNum:'',
                banks: ['中国工商银行','中国邮政储蓄银行','中国建设银行','中国农业银行','中国银行','中国光大银行','中信银行','广发银行','广州银行','广州农村商业银行股份有限公司','中信嘉华银行（中国）有限公司','安徽肥西农村商业银行股份有限公司','安徽马鞍山农村商业银行股份有限公司','安庆独秀农村商业银行股份有限公司','安顺商行','安阳商行','鞍山商行','包商银行','保定商行','北京农村商业银行股份有限公司','北京银行','本溪商行','渤海银行','沧州融信农村商业银行股份有限公司','沧州银行','常熟农村商业银行股份有限公司','朝阳商行','成都农村商业银行股份有限公司','成都银行','承德银行','池州九华农村商业银行股份有限公司','稠州商行','达州商行','大华银行（中国）有限公司','大连银行','大庆市商业银行','大同商行','大新银行（中国）有限公司','丹东商行','德阳商行','德意志银行（中国）有限公司','德州银行','东方汇理银行（中国）有限公司','东莞农村商业银行股份有限公司','东莞银行','东吴农村商业银行股份有限公司','东亚银行（中国）有限公司','东营商行','鄂尔多斯市东胜农村商业银行股份有限公司','鄂尔多斯银行','法国巴黎银行（中国）有限公司','法国兴业银行（中国）有限公司','顺德农村商业银行股份有限公司','福建海峡银行','抚顺商行','阜新银行','富滇银行','赣州商行','广西北部湾银行','贵阳商行','桂林商行','哈尔滨银行','邯郸商行','韩亚银行（中国）有限公司','汉口银行','杭州银行','合肥科技农村商业银行股份有限公司','河北银行','河南罗山农村商业银行股份有限公司','河南新县农村商业银行股份有限公司','荷兰银行（中国）有限公司','鹤壁商行','恒丰银行','恒生银行（中国）有限公司','衡水商行','衡阳商行','葫芦岛银行','湖州银行','花旗银行（中国）有限公司','华美银行（中国）有限公司','华侨银行（中国）有限公司','华商银行','华夏银行','华一银行','黄石银行','徽商银行','汇丰银行（中国）有限公司','吉林九台农村商业银行股份有限公司','吉林银行','济宁银行','嘉兴银行','江苏赣榆农村商业银行股份有限公司','江苏江南农村商业银行股份有限公司','江苏靖江农村商业银行股份有限公司','江苏射阳农村商业银行股份有限公司','江苏银行','江苏长江商行','江阴农村商业银行股份有限公司','交通银行','焦作商行','金华银行','锦州银行','晋城商行','晋商银行','晋中商行','荆州商行','九江银行','开封商行','库尔勒商行','奎屯商行','昆仑银行','昆山农村商业银行股份有限公司','莱商银行','兰州银行','廊坊银行','乐山商行','凉山州商行','辽宁葫芦岛连山农村商业银行股份有限公司','辽阳银行','临商银行','柳州商行','六盘水商行','龙江银行','泸州商行','洛阳银行','漯河商行','绵阳商行','民生银行','民泰商行','摩根大通银行（中国）有限公司','摩根士丹利国际银行（中国）有限公司','牡丹江市商业银行','南昌洪都农村商业银行股份有限公司','南昌银行','南充商行','南京银行','南宁市商业银行','南阳商行','南洋商业银行（中国）有限公司','内蒙古银行','宁波国际银行','宁波银行','宁夏黄河农村商业银行股份有限公司','宁夏银行','攀枝花商行','盘谷银行（中国）有限公司','盘锦商行','平安银行','平顶山商行','平凉商行','齐鲁银行','齐齐哈尔市商业银行','齐商银行','企业银行（中国）有限公司','秦皇岛商行','青岛银行','青海银行','曲靖市商业银行','泉州银行','日照银行','瑞穗实业银行（中国）有限公司','三井住友银行（中国）有限公司','三菱东京日联银行（中国）有限公司','三门峡湖滨农村商业银行股份有限公司','三门峡商行','厦门国际银行','厦门银行','山东莱州农村商业银行股份有限公司','山东寿光农村商业银行股份有限公司','山东邹平农村商业银行股份有限公司','商丘商行','上海农村商业银行股份有限公司','上海浦东发展银行','上海银行','上饶银行','绍兴银行','深圳发展银行','深圳农村商业银行股份有限公司','盛京银行','石嘴山银行','首都银行（中国）有限公司','遂宁商行','台州商行','太仓农村商业银行股份有限公司','泰安商行','泰隆商行','唐山商行','天津滨海农村商业银行股份有限公司','天津银行','铁岭商行','通用电气金融财务（中国）有限公司','外换银行（中国）有限公司','威海商行','潍坊银行','温州银行','乌海银行','乌鲁木齐商行','芜湖扬子农村商业银行股份有限公司','吴江农村商业银行股份有限公司','武汉农村商业银行股份有限公司','西安商行','锡州农村商业银行股份有限公司','湘潭商行','襄樊商行','孝感商行','协和银行','新韩银行（中国）有限公司','新乡银行','信阳商行','星展银行（中国）有限公司','邢台商行','兴业银行','许昌魏都农村商业银行股份有限公司','许昌银行','雅安商行','烟台银行','阳泉商行','伊川农村商业银行股份有限公司','宜宾商行','宜昌商行','营口银行','永亨银行（中国）有限公司','友利银行（中国）有限公司','玉溪商行','岳阳商行','枣庄商行','渣打银行（中国）有限公司','湛江商行','张家港农村商业银行股份有限公司','张家口商行','长安银行','长春农村商业银行股份有限公司','长沙银行','长治商行','招商银行','浙商银行','正信银行有限公司','郑州银行','重庆农村商业银行股份有限公司','重庆三峡银行','重庆银行','周口商行','珠海商行','株洲商行','驻马店商行','自贡商行','遵义商行','珠海农村商业银行股份有限公司','云南省农村信用社联合社','西安市商业银行','梧州市区农村信用合作联社','珠海华润银行','广东华兴银行股份有限公司广州分行营业部','珠海华润银行股份有限公司总部营业部','苏州银行股份有限公司营业部','美国银行有限公司北京分行','美国银行有限公司广州分行','美国银行有限公司上海分行','焦作中旅银行股份有限公司营业部','华融湘江银行股份有限公司','杭州联合农村商业银行股份有限公司','贵州银行股份有限公司','广东南粤银行股份有限公司','富民浦发村镇银行股份有限公司','中原银行股份有限公司营业部','安徽青阳农村商业银行股份有限公司清算中心','安徽省天长市农村信用联社清算中心','广东博罗农村商业银行股份有限公司','赤水市农村信用合作联社','电白县农村信用合作联社','江苏东海农村商业银行股份有限公司营业部','多伦县农村信用合作联社','广东南海农村商业银行股份有限公司','福建福州农村商业银行股份有限公司','巩义市农村信用合作联社','广东高明农村商业银行股份有限公司','广东顺德农村商业银行股份有限公司营业部','广东新兴农村商业银行股份有限公司','海口农村商业银行股份有限公司营业部','怀集县农村信用合作联社','济南市历城区农村信用合作联合社营业部','江苏建湖农村商业银行股份有限公司营业部','江苏丹阳农村商业银行股份有限公司营业部','江苏东台农村商业银行股份有限公司营业部','江苏江都农村商业银行股份有限公司营业部','江苏江阴农村商业银行股份有限公司','江苏姜堰农村商业银行股份有限公司营业部','江苏海门农村商业银行股份有限公司营业部','江苏淮安农村商业银行股份有限公司','江苏泰州农村商业银行股份有限公司营业部','江苏盐城农村商业银行股份有限公司','江苏宜兴农村商业银行股份有限公司营业部','江西省农村信用社联合社','广东揭阳农村商业银行股份有限公司','连城县农村信用合作联社营业部','廉江市农村信用合作联社','临安市农村信用合作联社','闽侯县农村信用合作联社营业部','浙江南浔农村合作银行','宁波鄞州农村商业银行股份有限公司','青岛农村商业银行','广东清远农村商业银行股份有限公司','琼海市农村信用合作联社营业部','青州市农村信用合作联社','山东圣泰农村合作银行','山西运城农村商业银行股份有限公司','台山市农村信用合作联社','太原市城区农村信用合作联社','新丰县农村信用合作联社','湖南新宁农村商业银行股份有限公司','广东阳东农村商业银行股份有限公司','九龙县农村信用合作联社','浙江杭州余杭农村合作银行营业部','浙江上虞农村商业银行股份有限公司营业部','浙江绍兴瑞丰农村商业银行股份有限公司','浙江永康农村商业银行股份有限公司营业部','肇庆端州农村商业银行股份有限公司','珠海农村商业银行股份有限公司','珠海农村商业银行股份有限公司','富民县农村信用合作联社','中山农村商业银行股份有限公司','福建福州农村商业银行股份有限公司','潮州农村商业银行股份有限公司','广西桂林漓江农村合作银行','肇庆市鼎湖区农村信用合作联社','江苏沭阳农村商业银行营业部','广东四会农村商业银行股份有限公司','深泽县农村信用联社股份有限公司兴泽信用社','连州市农村信用合作联社','新疆博乐农村商业银行股份有限公司','彭州民生村镇银行有限责任公司','新疆喀什农村商业银行股份有限公司','封开县农村信用合作联社','济宁市任城区农村信用合作联社','江门新会农村商业银行股份有限公司','江苏启东农村商业银行股份有限公司','无锡农村商业银行股份有限公司','中国信托商业银行','广西阳朔农村合作银行','甘肃银行股份有限公司','广东省农村信用社联合社','湛江农村商业银行股份有限公司','佛山农村商业银行股份有限公司','福建省农村信用社联合社','贵州从江农村商业银行股份有限公司','内蒙古察哈尔右翼前旗农村商业银行股份有限公司','蒙商银行','内蒙古赤峰市巴林左旗哈拉哈达镇农村信用社','黑龙江省农村信用社','内蒙古赤峰市巴林左旗农村信用社','湖南湘江新区农村商业银行','唐县农村信用合作联社','厦门农村商业银行股份有限公司','江西进贤农村商业银行股份有限公司','浙江网商银行股份有限公司','湛江农村商业银行股份有限公司','江苏姜堰农村商业银行股份有限公司','深圳光明沪农商村镇银行股份有限公司','广东仁化农村商业银行股份有限公司','威海市商业银行股份有限公司','乐东黎族自治县农村信用合作联社','沈阳农村商业银行股份有限公司','徐州淮海农村商业银行股份有限公司','厦门农村商业银行股份有限公司','安庆农村商业银行股份有限公司','广州番禺新华村镇银行股份有限公司','浙江长兴农村商业银行股份有限公司营业部','广东龙门农商银行股份有限公司','德庆县农村信用合作联社','山东惠民舜丰村镇银行股份有限公司','菏泽农村商业银行','江苏泰州农村商业银行股份有限公司','广东龙门农村商业银行股份有限公司','北京顺义银座村镇银行股份有限公司','国民银行(中国)有限公司','浙江德清农村商业银行股份有限公司','浙江泰隆商业银行股份有限公司','深泽县农村信用联社股份有限公司','江苏仪征农商业银行股份有限公司','江西银行股份有限公司','广东信宜农村商业银行股份有限公司','浙江禾城农村商业银行股份有限公司','滨州农村商业银行','中江县农村信用合作社联合社','浙江温州龙湾农村商业银行股份有限公司','延安农村商业银行股份有限公司','广东龙门农村商业银行股份有限公司','梅州农村商业银行股份有限公司','浙江禾城农村商业银行股份有限公司','深圳光明沪农商村镇银行股份有限公司','广东顺德农村商业银行股份有限公司','江西宜丰农村商业银行股份有限公司','柳林农商银行','浙江金华成泰农村商业银行股份有限公司','湖北银行股份有限公司','聊城农村商业银行','南阳市宛城区农村信用合作联社','湖南宁乡农村商业银行股份有限公司','佛山市三水区农村信用合作联社','德阳农村商业银行股份有限公司','广西靖西农村商业银行股份有限公司','广东南海农村商业银行股份有限公司','江西进贤农村商业银行','将乐县农村信用合作联社营业部','东莞农村商业银行股份有限公司','深圳宝安桂银村镇银行股份有限公司','广东省湛江农村商业银行股份有限公司','广东仁化农村商业银行股份有限公司','南宁市区农村信用合作联社','徐州农村商业银行股份有限公司','浙江富阳农村商业银行股份有限公司营业部','浙江永嘉农村商业银行股份有限公司','江西银行股份有限公司','韶关农村商业银行股份有限公司','湖南湘江新区农村商业银行股份有限公司','江西进贤农村商业银行股份有限公司','绵阳市商业银行股份有限公司总行营业部','广东省农村信用合作社阳江农村商业银行营业部','浙江苍南农村商业银行股份有限公司','广东茂名农村商业银行股份有限公司','广西苍梧农村商业银行股份有限公司','湛江农村商业银行股份有限公司','浙江桐庐农村商业银行股份有限公司','江苏宝应农村商业银行','平乡县农村信用合作联社','广东翁源农村商业银行股份有限公司总行营业部','山西柳林农村商业银行','湖南湘江新区农村商业银行股份有限公司','阜阳颍泉农村商业银行股份有限公司','台山市农村信用合作联社','景德镇农村商业银行股份有限公司','广东连州农村商业银行股份有限公司'],
                bankSearchValue:'',
                showPicker: false,
                showloading: false,
                ttCode:'',
                pid:'',
                showHandler:true,
                isForbidden:false,
            };
        },
        methods: {
            getBankList(f){
                let res = [];
                this.banks.forEach(item=>{               
                    if(this.bankSearchValue){
                        if(item.indexOf(this.bankSearchValue)>-1){
                            res.push(item);
                        }
                    }else{
                        res = this.banks;
                    }
                });
                return res;
            },
            onConfirm(val) {
                this.bankName = val;
                this.showPicker = false;
            },
            toastError(res) {
                Toast({
                    message: res.code + ":" + res.message,
                    position: "top",
                    type: "fail",
                });
                return "";
            },
            chooseBank(){
                if(this.isForbidden){
                    this.showPicker = false;
                }else{
                    this.showPicker = true;
                }
                
            },
            onSubmit() {
                if (this.bankName == "") {
                    Toast({
                        message: "请选择银行",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                if (this.bankCardNum == "") {
                    Toast({
                        message: "请输入银行卡号",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                if(!this.luhnCheck(this.bankCardNum)){
                    Toast({
                        message: "银行卡号不合法",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                let param = {pid:this.pid,url:this.ttCode,bankNum:this.bankCardNum,bankName:this.bankName};
                this.showloading = true;
                apiLoginPage
                    .bankNumCheckInRegist(param)
                    .then((res) => {
                        this.showloading = false;
                        if(res.code=="200"){
                            Toast({
                                message: "登记成功",
                                position: "top",
                                type: "success",
                            });
                            Dialog.alert({
                                title: "登记成功",
                                message: "银行卡信息已登记成功",
                            }).then(() => {
                                wx.closeWindow();
                            });
                        }else{
                            Toast({
                                message: res.message,
                                position: "top",
                                type: "fail",
                            });
                        }
                    });
            },
            luhnCheck(bankno){
                var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhn进行比较）
                var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
                var newArr = new Array();
                for (var i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
                    newArr.push(first15Num.substr(i, 1));
                }
                var arrJiShu = new Array(); //奇数位*2的积 <9
                var arrJiShu2 = new Array(); //奇数位*2的积 >9
                var arrOuShu = new Array(); //偶数位数组
                for (var j = 0; j < newArr.length; j++) {
                    if ((j + 1) % 2 == 1) { //奇数位
                        if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
                        else arrJiShu2.push(parseInt(newArr[j]) * 2);
                    } else //偶数位
                    arrOuShu.push(newArr[j]);
                }
                var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
                var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
                for (var h = 0; h < arrJiShu2.length; h++) {
                    jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
                    jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
                }
                var sumJiShu = 0; //奇数位*2 < 9 的数组之和
                var sumOuShu = 0; //偶数位数组之和
                var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
                var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
                var sumTotal = 0;
                for (var m = 0; m < arrJiShu.length; m++) {
                    sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
                }
                for (var n = 0; n < arrOuShu.length; n++) {
                    sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
                }
                for (var p = 0; p < jishu_child1.length; p++) {
                    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
                    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
                }
                //计算总和
                sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);
                //计算luhn值
                var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
                var luhn = 10 - k;
                if (lastNum == luhn) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        created() {
            this.showloading = true;
            let param = {pid:this.$route.query.pid,url:this.$route.query.url};
            apiLoginPage.bankNumCheckIn(param).then((res)=>{
                this.showloading = false;
                if(res.data){
                    let data = res.data;
                    this.sno = data.userCode;
                    this.name = data.userName;
                    if(data.idNum){
                        this.bankCardNum = data.bankCard;
                        this.bankName = data.idNum;
                        this.showHandler = false;
                        this.isForbidden = true;
                    }else{
                        this.ttCode = data.bankCard;
                        this.pid = data.userId;
                    }
                }
            }).catch((err)=>{
                this.showloading = false;
                this.showHandler = false;
            })
        },
    };
</script>